import type { ReactNode } from 'react';
import { useIsSecurityEnabled } from '../../../helpers/features';

/**
 * Access gate which renders any children, but only if security is enabled for the org.
 *
 * @example - Button only renders if security is enabled:
 * <SecurityRequired>
 *   <Button>Download Security Report</Button>
 * </SecurityRequired>
 */
const SecurityRequired = ({ children }: { children: ReactNode }) => {
  const hasSecurity = useIsSecurityEnabled();

  if (!hasSecurity) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default SecurityRequired;
